import Api from './ApiService'

export default {
    get(keyword, pageNumber, pageSize, order, UserId, numberPhone, senderPhone, recipientId, phoneNumber, beforeId, afterId) {
        let url = `message?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}&UserId=${UserId}&numberPhone=${numberPhone}&senderPhone=${senderPhone}&recipientId=${recipientId}`;
        if (phoneNumber) url += `&phoneNumber=${phoneNumber}`;
        if (beforeId) url += `&beforeId=${beforeId}`;
        if (afterId) url += `&afterId=${afterId}`;
        return Api().get(url);
    },
    getByUser(keyword, pageNumber, pageSize, order, UserId, numberPhone, senderPhone, recipientId) {
        return Api().get(`message/users-messages?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}&UserId=${UserId}&numberPhone=${numberPhone}&senderPhone=${senderPhone}&recipientId=${recipientId}
        `);
    },
    getOne(id) {
        return Api().get(`message/${id}`);
    },
    /** Resumo global de não lidas (independente da paginação) */
    getUnreadSummary() {
        return Api().get(`message/unread-summary`);
    },
    create(data) {
        return Api().post(`message`, data);
    },
    update(data) {
        return Api().put(`message/${data.id}`, data);
    }
}